export const ROW_PER_PAGE = [10, 25, 50];
export const HOME_PAGE_ROWS_PER_PAGE = 5;
export const DEFAULT_PAGE_SIZE = 25;

export const DOCUMENT_TYPES = {
  PV: 'PV',
  CIVIL: 'Civil',
  JUDGEMENT_ADD: 'Jugement Add',
  EXPERT_REPORT: 'Rapport d’expertise',
  EXPERT_REPORT_APPEAL: 'Rapport d’expertise appel',
  JUDGEMENT_ON_MERITS: 'Jugement au fond',
  CIVIL_JUDGEMENT: 'Jugement civil',
  CONSULTANCY_REPORT: 'Rapport de conseil',
  JUGDEMENT_APPEAL_COURT: "Arrêt de la cour d'appel",
  TAX: 'Taxe',
  THUMBNAIL: 'Vignette',
  TRAVELLING_EXPENSES: 'Frais de déplacement',
  COUT_PV: 'Coût de PV',
  APPEAL_ADD: 'Arrêt ADD',
  APPEAL_ON_MERITS: 'Arrêt Civil',
  CIVIL_PROCEEDING: 'Citation',
  CIVIL_PROCEEDING_REQUEST: 'Requête',
  INVITATION: 'Convocation',
  CONTESTATION_REQUEST: 'Requete contestation',
  CONTESTATION_ACT: 'Acte opposition',
  CONTESTATION: 'Decision contestation',
  SUPPORT_DOCUMENT: 'Document complémentaire',
  SUPPORT_DOCUMENT_CIVIL_PARTY: 'Document complémentaire constitution civile',
  SUPPORT_DOCUMENT_JUDGEMENT_ADD: 'Document complémentaire jugement add',
  SUPPORT_DOCUMENT_EXPERT_REPORT: "Document complémentaire rapport d'expertise",
  SUPPORT_DOCUMENT_JUDGEMENT_ON_MERITS:
    'Document complémentaire jugement au fond',
  SUPPORT_DOCUMENT_APPEAL_ADD: 'Document complémentaire arrêt add',
  SUPPORT_DOCUMENT_APPEAL_EXPERT_REPORT:
    "Document complémentaire appel rapport d'expertise",
  SUPPORT_DOCUMENT_APPEAL_ON_MERITS: 'Document complémentaire arrêt au fond',
  NOTICE_DEFICIENCY: 'PV de carence',
  POSTPONEMENTS_EXPERTISE: "Report d'expertise",
  RAPPORT_CONSEIL: 'RAPPORT CONSEIL',
  INVOICE_DOCUMENT: 'Facture',
  INCOME_CERTIFICATE: 'Attestation de revenu',
  SCHOOLING_CERTIFICATE: 'Certificat de scolarité',
  QUITTANCE_TRANSACTION: 'Quittance transaction',
  REQUEST_TRANSACTION: 'Demande de la transaction',
};

export const DATE_FORMAT: string = 'YYYY-MM-DD';

export const DATE_PICKET_FORMAT: string = 'dd/MM/yyyy';
export const NORMAL_DATE_FORMAT: string = 'DD/MM/YYYY';
export const SECOND_DATE_PICKET_FORMAT: string = 'yyyy-MM-dd';
